import React, { useEffect } from 'react';
import { CircularProgress, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { useDispatch } from 'react-redux';
import allActions from '../../../actions';
import { StatusDpinDairAPI } from '../../../API/status_dpin_dair';
import { unoTheme, useColors } from '../../../assets/styles/unoTheme';
import MyTable from '../../utils/MyTable';
import { formatDataToPieChart, getMonthName } from '../../utils/utils';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',

    '& .content-div': {
      height: 'calc(100vh - 103px) !important',
      overflowY: "scroll",
    }
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    backgroundColor: unoTheme.hoverTable,
  },
  leftHeader: {

    display: 'flex',
    flexDirection: 'column',
    //alignItems: 'center',
  },
  fundLabel: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1C2228'
  },
  accountLabel: {
    fontSize: '14px',
    color: unoTheme.secondaryColor,
  },
  spacingLeft2: {
    marginLeft: theme.spacing(2)
  },
  green: {
    color: unoTheme.greenMoney,
  },

  addCommentLabel: {
    cursor: "pointer",
    color: unoTheme.defaultTextColor,

    '&:hover': {
      color: unoTheme.mainColor,
    }
  },
  rightDivBackdrop: {
    zIndex: 3,
    backgroundColor: 'white',
    position: 'absolute',
    opacity: 0.85,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    color: unoTheme.mainColor,
    alignItems: 'center',
    justifyContent: 'center',

    '& .progress': {
      color: unoTheme.mainColor
    }
  },
  divChart: {
    padding: "24px",
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

}));


export default function StatusesClientsByMonth({ content }) {
  const dispatch = useDispatch();

  const {
    data: {
      month,
      year,
      isDPIN,
      advisorId,
      consultingId,
      search,
      dairStatusIdFilter,
      monthFilterDair,
      dpinStatusIdFilter,
      snapshotDate,
      mode, // 'XML_AUDESP_MONTH' | 'XML_AUDESP_TRI' (quando ausente, usa isDPIN/DAIR)
      period, // mês (1-12) ou trimestre (1-4) para XML-AUDESP
      xmlAudespStatusIdFilter }
  } = content;

  const isXml = mode === 'XML_AUDESP_MONTH' || mode === 'XML_AUDESP_TRI';
  const isXmlTri = mode === 'XML_AUDESP_TRI';

  const headerLabel = isXml ? "XML - AUDESP" : (isDPIN ? "DPIN" : "DAIR");
  const periodLabel = isXml
    ? (isXmlTri ? (period + "º Tri/" + year) : (getMonthName(period) + "/" + year))
    : (isDPIN ? year : (getMonthName(monthFilterDair) + "/" + year));

  const classes = useStyles();

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [data, setData] = useState(null);
  const [dataChart, setDataChart] = useState(null);

  const [dairSelected, setDairSelected] = useState(null);


  const loadData = async (
    month,
    year,
    isDpin,
    advisorId,
    consultingId,
    search,
    dairStatusIdFilter,
    monthFilterDair,
    dpinStatusIdFilter,
    snapshotDate
  ) => {

    setOpenBackdrop(true)

    const response = isXml
      ? await StatusDpinDairAPI.getCountStatusesXmlAudespByClientFilter(
        year,
        isXmlTri ? 'tri' : 'month',
        period,
        advisorId,
        consultingId,
        search,
        xmlAudespStatusIdFilter,
        snapshotDate
      )
      : await StatusDpinDairAPI.getCountStatusesByClientFilter(
        year,
        advisorId,
        consultingId,
        search,
        dairStatusIdFilter,
        monthFilterDair,
        dpinStatusIdFilter,
        snapshotDate,
        isDpin
      );


    if (response.success) {

      const formattedData = [];
      const arrayToChart = [];
      const colorsToChart = [];

      Object.entries(response.body.rows).map(([key, info]) => {
        arrayToChart.push({
          label: key,
          value: info.rows.length,
        })
        colorsToChart.push(info.color);

        formattedData.push({
          label: key,
          color: info.color,
          count: info.rows.length,
          clients: info.rows
        })
      });

      formattedData.sort((a, b) => b.count - a.count);

      setData(formattedData);
      setDataChart(formatDataToPieChart(arrayToChart, colorsToChart));
      setOpenBackdrop(false);
    }

  }

  useEffect(() => {
    if (!year) return;
    loadData(
      month,
      year,
      isDPIN,
      advisorId,
      consultingId,
      search,
      dairStatusIdFilter,
      monthFilterDair,
      dpinStatusIdFilter,
      snapshotDate);
  }, [month, year, isDPIN, advisorId, consultingId, search, dairStatusIdFilter, monthFilterDair, dpinStatusIdFilter, snapshotDate, mode, period, xmlAudespStatusIdFilter]);

  return (
    <div className={classes.root}>

      <Paper style={{ marginBottom: '4px' }}>
        <div className={classes.header}>
          <div className={classes.leftHeader}>
            <div>
              <Typography
                align={'left'}
                className={classes.fundLabel}>
                {`${headerLabel} - Contagem de Status`}
              </Typography>
              <Typography
                align={'left'}
                className={classes.accountLabel}>

                <span>Período:
                  <Typography component="strong" style={{ color: unoTheme.mainColor, marginLeft: "8px" }}>{periodLabel}</Typography>
                </span>

              </Typography>
            </div>
          </div>

          <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
            <CloseIcon />
          </IconButton>

        </div>
      </Paper>

      <div className="content-div">

        <div className={classes.divChart}>
          {
            dataChart ?
              <Pie data={dataChart}
                options={{
                  responsive: true,
                  //maintainAspectRatio: false,
                  legend: {
                    display: true,
                    position: 'bottom',
                    fullWidth: true,
                  },
                }}

              /> : null
          }
        </div>

        <div style={{ height: "auto" }}>

          {
            dairSelected ?
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "16px" }}>
                  <IconButton onClick={() => setDairSelected(null)}>
                    <ArrowBackIcon />
                  </IconButton>
                  <Typography style={{ color: dairSelected.color }}>
                    <strong>{dairSelected.label}</strong>
                  </Typography>
                </div>
                <Typography style={{ marginRight: "16px" }}>
                  <strong>{dairSelected.count}</strong>
                </Typography>
              </div> : null
          }

          <MyTable
            heightAuto
            stickyHeader
            nofixed={true}
            size="small"
            selectable="true">
            {
              dairSelected ? null :
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="center">Nº de clientes</TableCell>
                  </TableRow>
                </TableHead>
            }
            {
              dairSelected ?
                <TableBody>
                  {dairSelected?.clients?.map((obj, index) => (
                    <TableRow key={'clients-in-status-' + index}>
                      <TableCell align="left" className={"ellipsis"}>{obj.label_name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                :
                <TableBody>
                  {data?.map((obj, index) => (
                    <TableRow key={'status-counts-' + index} onClick={() => setDairSelected(obj)}>
                      <TableCell align="left" style={{ color: obj.color }} className={"ellipsis"}><strong>{obj.label}</strong></TableCell>
                      <TableCell align="center">{obj.count}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
            }
          </MyTable>
        </div>
      </div>

      {
        openBackdrop ?
          <div className={classes.rightDivBackdrop}>
            <CircularProgress className={'progress'} />
            <Typography variant={'body1'} style={{ marginTop: '16px' }}>
              Carregando contadores...
            </Typography>

          </div> : null
      }
    </div>
  )
}
